import { Link, Outlet, useMatches, useRouteError, isRouteErrorResponse } from 'react-router-dom'
import { useEffect, type ReactNode } from 'react'
import { useSession } from '../lib/session'
import { BrandLogo } from '../features/auth/AuthShell'

/** Raiz do roteador: põe o título da aba conforme a rota (handle.title do último trecho que tiver um). */
export default function Root() {
  const matches = useMatches() as Array<{ handle?: { title?: string } }>
  const title = [...matches].reverse().find((m) => m.handle?.title)?.handle?.title
  useEffect(() => { document.title = title ? `${title} · Seu Impulso` : 'Seu Impulso' }, [title])
  return <Outlet />
}

/** Casca das telas de erro: logo de verdade centralizado e cartão com a mensagem. */
function ErrorScreen({ title, text, role, children }: { title: string; text: string; role?: 'alert'; children: ReactNode }) {
  return (
    <div className="auth-wrap" style={{ background: 'var(--bg)' }}>
      <div className="auth-card">
        <BrandLogo />
        <div className="card" style={{ padding: 24, textAlign: 'center' }} role={role}>
          <h1 style={{ fontSize: 22 }}>{title}</h1>
          <p className="muted mt-8">{text}</p>
          <div className="row mt-16" style={{ justifyContent: 'center', gap: 8, flexWrap: 'wrap' }}>{children}</div>
        </div>
      </div>
    </div>
  )
}

/** Quem está logado volta ao painel; quem não está volta à página inicial (a ação principal muda de lugar). */
function BackLinks() {
  const { me } = useSession()
  return me ? (
    <>
      <Link className="btn primary" to="/app">Ir para o painel</Link>
      <Link className="btn" to="/">Página inicial</Link>
    </>
  ) : (
    <>
      <Link className="btn primary" to="/">Página inicial</Link>
      <Link className="btn" to="/login">Entrar</Link>
    </>
  )
}

/** Tela para qualquer erro inesperado de uma página (no lugar da mensagem em inglês do React Router). */
export function RouteError() {
  const error = useRouteError()
  const { me } = useSession()
  useEffect(() => { document.title = 'Algo deu errado · Seu Impulso' }, [])
  if (isRouteErrorResponse(error) && error.status === 404) return <NotFound />
  return (
    <ErrorScreen role="alert" title="Algo deu errado" text="Tivemos um problema para mostrar esta página. Seus dados estão salvos. Tente recarregar; se continuar, volte ao início.">
      <button type="button" className="btn primary" onClick={() => window.location.reload()}>Recarregar a página</button>
      <a className="btn" href={me ? '/app' : '/'}>Ir para o início</a>
    </ErrorScreen>
  )
}

export function NotFound() {
  return (
    <ErrorScreen title="Página não encontrada" text="O endereço pode ter mudado ou estar digitado errado.">
      <BackLinks />
    </ErrorScreen>
  )
}
